import { Heading } from "@overmap-ai/blocks"
import { memo } from "react"

import { BaseTopBar } from "../TopBars/BaseTopBar"

export const ProjectDashboardViewTopBar = memo(() => {
	return (
		<BaseTopBar
			leftContent={
				<Heading size="sm" accentColor="base">
					Dashboard
				</Heading>
			}
		/>
	)
})
ProjectDashboardViewTopBar.displayName = "ProjectDashboardViewTopBar"
